import { h, render, Component } from 'preact';
import Cookies from 'universal-cookie';

import Dialog from 'q-mdc/elements/material-dialog';
import List from 'q-mdc/elements/material-list';
import ListItem from 'q-mdc/elements/material-list-item';
import Tabs from 'q-mdc/elements/material-tabs';
import Search from '../../icons/searchIcons/search';
import Close from '../../icons/close';
import GPS from '../../icons/headerIcons/gps';

import { detectLocations, searchCityDefaultCallback } from '../../../helpers/location';
import { CITY_COOKIE_TTL, COOKIE_DOMAIN, STATE_NAME_COOKIE_KEY, STATE_ID_COOKIE_KEY, CITY_NAME_COOKIE_KEY, CITY_ID_COOKIE_KEY } from '../../../helpers/constants';
import SnackBar from '../../SnackBar';

import './index.scss';

const topCityList = [
    {'name':'Ahmedabad', id:'22'},
    {'name':'Bangalore', id:'23'},
    {'name':'Chandigarh', id:'24'},
    {'name':'Chennai', id:'25'},
    {'name':'Coimbatore', id:'26'},
    {'name':'Delhi', id:'27'},
    {'name':'Hyderabad', id:'28'},
    {'name':'Kochi', id:'29'},
    {'name':'Kolkata', id:'30'},
    {'name':'Mumbai', id:'31'},
    {'name':'Pune', id:'33'},
    {'name':'Gurgaon', id:'132222'},
    {'name':'Jaipur', id:'152222'},
    {'name':'Lucknow', id:'162222'},
    {'name':'Noida', id:'201301'},
    {'name':'NaviMumbai', id:'400701'}
];

const cookies = new Cookies();

class CitySelection extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            isClicked : 0,
            showSnackBar: false
        }
    }
    
    handleCitySearchClick = (cityId, cityName) => {
        const cityInCookie = cookies.get('new_prefer_city');
        const { closePopup , searchCityCallback , close } = this.props;
        // If the user selects same city more than once
        if (cityInCookie && cityInCookie.toLowerCase() === cityName.toLowerCase()) {
            close();
            return;
        }

        let {g_id, match} = this.props;
        g_id = g_id || 0;

        const cityCookieName = cityName === 'All India' ? 'www' : cityName.toLowerCase();

        cookies.set(CITY_NAME_COOKIE_KEY, cityCookieName, {
            path: '/',
            maxAge: CITY_COOKIE_TTL,
            domain: COOKIE_DOMAIN
        });
        cookies.set(CITY_ID_COOKIE_KEY, cityId, {
            path: '/',
            maxAge: CITY_COOKIE_TTL,
            domain: COOKIE_DOMAIN
        });

        if (searchCityCallback) {
            searchCityCallback(cityId, cityName, g_id, match);
        } else {
            searchCityDefaultCallback(cityId, cityName, g_id, match);
        }
    }

    handleDetectLocationClick = () => {
        navigator.permissions.query({ name: 'geolocation' }).then((result) => {
            const permissionStatus = result.state;
            if (permissionStatus === 'prompt' || permissionStatus === 'granted') {
                detectLocations((res) => {
                    const { cityId, cityName } = res;
                    this.handleCitySearchClick(cityId, cityName);
                }, (err) => {
                    if (err && err.code === 1) {
                        this.snackBarMessage = 'You have blocked Quikr from using your location. To enable this, change your location settings.';
                    } else {
                        this.snackBarMessage = 'Something went wrong. Please try again after some time.';
                    }
                    this.setState({
                        showSnackBar: true
                    });
                });
            } else {
                this.snackBarMessage = 'You have blocked Quikr from using your location. To enable this, change your location settings.';
                this.setState({
                    showSnackBar: true
                });
            }
        });
    }

    handleSnackBarClose = () => {
        this.setState({
            showSnackBar: false
        });
    }

    handleToggle = (index) => {
        this.setState ({
            isClicked: index
        });
    }

    handleStateSelect = (e,stateName,stateId) => {
        e.preventDefault();
        cookies.set(STATE_NAME_COOKIE_KEY, stateName.toLowerCase(), {
            path: '/',
            maxAge: CITY_COOKIE_TTL,
            domain: COOKIE_DOMAIN
        });
        cookies.set(STATE_ID_COOKIE_KEY, stateId, {
            path: '/',
            maxAge: CITY_COOKIE_TTL,
            domain: COOKIE_DOMAIN
        });
        this.props.searchStateCallback(stateId,stateName,this.props.g_id,this.props.match);
    }

    renderItem = (data,type) => {
        let html = [];
        data.map((state) => {
            if (type == 'state') {
                html.push(<a href="#" key={state.id} onClick={(e)=>{this.handleStateSelect(e,state.name,state.id)}}>{state.name}</a>);
            } else {
                html.push(<a href="#" key={state.id} onClick={(e)=>{e.preventDefault(); this.handleCitySearchClick(state.id,state.name)}}>{state.name}</a>);
            }
        })
        return html;
    }

    getPartialLists = (list) => {
        const columns = 4;
        const rows = list.length/columns ;
        let partialList = [];
        for (let i = 0; i < columns; i++) {
            partialList[i] = list.slice(i*rows,(rows*(i+1)));
        }
        return partialList;
    }
    
    render(props){
        const { stateList = null , cityList=topCityList , results=[] , handleSearch , close } = props;
        if (cityList.length>0 || results.length>0) {
            const partialStateLists = stateList ? this.getPartialLists(stateList) : null;
            const partialCityList = results.length>0 ? results : this.getPartialLists(cityList);
            let allIndiaItem;
            return(
                <div>
                    <header class="mdc-dialog__header">
                        <span class="close-dialog" onClick={close} title="Close"><Close /></span>
                        <h2>Select Location</h2>
                        <span class="navigation" title="Detect" onClick={this.handleDetectLocationClick}>DETECT <GPS /></span>
                    </header>
                    <Tabs>
                        <Tabs.Tab active={true} onClick={e => this.handleToggle(0)}>City</Tabs.Tab>
                        {stateList && <Tabs.Tab onClick={e => this.handleToggle(1)}>States</Tabs.Tab>}
                    </Tabs>

                    <Dialog.Body scrollable={false}>
                        <div class={`tab-content ${this.state.isClicked ===0 ? 'active' : ''}`}>
                            <div class="city-dialog__search">
                                <Search />
                                <input type="text" class="city-dialog__search--field" onkeyup={handleSearch} placeholder="Search for your City" />
                            </div>
                            {results.length>0 ? 
                                <List>
                                    <ListItem>
                                        {results.map((item)=>{
                                            if(item.cityId && item.cityName)
                                            {
                                                if (item.cityId == 0 || item.cityId == 1) {
                                                    allIndiaItem = [<a href="#" key={item.cityId} onClick={(e)=>{e.preventDefault(); this.handleCitySearchClick(item.cityId,item.cityName)}}>{item.cityName}</a>]
                                                } else {
                                                    return <a href="#" key={item.cityId} onClick={(e)=>{e.preventDefault(); this.handleCitySearchClick(item.cityId,item.cityName)}}>{item.cityName}</a>
                                                }
                                            }
                                            else if(item.id && item.name)
                                            {
                                                if (item.id == 0 || item.id == 1) {
                                                    allIndiaItem = [<a href="#" key={item.id} onClick={(e)=>{e.preventDefault(); this.handleCitySearchClick(item.id,item.name)}}>{item.name}</a>]
                                                } else {
                                                    return <a href="#" key={item.id} onClick={(e)=>{e.preventDefault(); this.handleCitySearchClick(item.id,item.name)}}>{item.name}</a>
                                                }
                                            }
                                            
                                        })}
                                        {allIndiaItem}
                                    </ListItem>
                                </List>
                                :
                                <div>
                                    <h3>Popular Cities</h3>
                                    <List>
                                        {partialCityList.map((cityList)=>{
                                            return (<ListItem>{this.renderItem(cityList,'city')}</ListItem>)
                                        })}
                                    </List>
                                </div>
                            }
                        </div>
                        {stateList &&
                            <div class={`tab-content ${this.state.isClicked ===1 ? 'active' : ''}`}>
                                <List>
                                    {partialStateLists.map((stateList,i)=>{
                                        return (<ListItem>{this.renderItem(stateList,'state')}</ListItem>)
                                    })}
                                </List>
                            </div>
                        }
                    </Dialog.Body>
                    {this.state.showSnackBar &&
                        <SnackBar
                            text={this.snackBarMessage}
                            active
                            timeout={5000}
                            onClose={this.handleSnackBarClose}
                            children={<a onClick={this.handleSnackBarClose}>CLOSE</a>}
                        />
                    }
                </div>
            );
        }
    }
}
export default CitySelection;


// WEBPACK FOOTER //
// ../q-components/components/desktop/city/index.js